import { toastMessage } from "./toastMessage";

const agbCheckboxEl = document.querySelector("#agb");
const agbBlockedBtnEls = document.querySelectorAll("a[data-enable-on-agb-check]");
const agbInfoTriggerEls = document.querySelectorAll("[data-agb-info]");

try {
  if (agbCheckboxEl) {
    const State = {
      agb_checked: false,
      update: function (props) {
        if (props) {
          Object.keys(props).forEach((key) => {
            if (key in this) {
              this[key] = props[key];
            }
          });
        }

        const cl_mode = this.agb_checked ? "remove" : "add";

        agbBlockedBtnEls.forEach((agbBlockedBtnEl) => {
          agbBlockedBtnEl.classList[cl_mode]("disabled");
        });
      },
    };

    State.update({ agb_checked: agbCheckboxEl.checked });

    agbCheckboxEl.addEventListener("change", () => {
      State.update({ agb_checked: agbCheckboxEl.checked });
    });

    agbInfoTriggerEls.forEach((agbInfoTriggerEl) => {
      agbInfoTriggerEl.addEventListener("click", (e) => {
        if (!State.agb_checked) {
          toastMessage("Bitte lesen und akzeptieren Sie die AGBs.");
        }
      });
    });

    agbBlockedBtnEls.forEach((agbBlockedBtnEl) => {
      agbBlockedBtnEl.addEventListener("click", (e) => {
        if (!State.agb_checked) {
          e.preventDefault();
        }
      });
    });
  }
} catch (error) {
  console.error(error);
}
